import { useQuery } from "@tanstack/react-query";
import { fileServices } from "./file.services";
import { FILE_KEYS } from "./file.keys";
import { GetFilesParams } from "./file.types";

export const useGetFiles = (params?: GetFilesParams, enabled = true) => {
  return useQuery({
    queryKey: FILE_KEYS.list(params),
    queryFn: () => fileServices.getFiles(params),
    enabled,
  });
};

export const useGetFile = (id?: string) => {
  return useQuery({
    queryKey: FILE_KEYS.detail(id!),
    queryFn: () => fileServices.getFile(id!),
    enabled: !!id,
  });
};

export const useGetMyFiles = (params?: GetFilesParams) => {
  return useQuery({
    queryKey: FILE_KEYS.myFiles(params),
    queryFn: () => fileServices.getMyFiles(params),
  });
};
